import React from 'react';
import { BaasicSelect, Loader } from 'core/components';
import { defaultTemplate } from 'core/hoc';

function LookupSelectTemplate({ lookupViewStore, t }) {
	if (lookupViewStore.loading && !lookupViewStore.editModal.isOpen) return <Loader />;
	const { options, onLookupSelect, selectedLookup } = lookupViewStore;
	return selectedLookup ? (
		<div className="header__right--lookup">
			<BaasicSelect
				placeholder={t('SELECTLOOKUP')}
				options={options.slice()}
				isClearable={true}
				onChange={onLookupSelect}
				value={selectedLookup}
			/>
		</div>
	) : null;
}

LookupSelectTemplate.propTypes = {};

export default defaultTemplate(LookupSelectTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/lookup/pages/LookupSelectTemplate.jsx